module.exports = __webpack_public_path__ + "img/zwtp.81495365.png";